import React from 'react'
import { Box, Grid } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import { CefrLevelCode, LanguageCode, Certification } from 'src/types'

import Action from 'src/ui/Action/Action'
import Certificate from 'src/ui/Certificate/Certificate'
import PageWrapupCard from 'src/ui/PageWrapup/subcomponents/PageWrapupCard/PageWrapupCard'

export type Props = {
  cefrLevel: CefrLevelCode
  l2Code: LanguageCode
  hoursOfLessons: number
  hoursOfStudy: number
  fullName: string
  certification: Certification
}

const LevelWrapupCertificate: React.FC<Props> = ({
  cefrLevel,
  l2Code,
  hoursOfLessons,
  hoursOfStudy,
  fullName,
  certification,
}) => {
  return (
    <PageWrapupCard
      sx={{
        py: { _: '3x', tablet: '4x' },
        px: { _: '3x', tablet: '5x' },
      }}
    >
      <Grid
        gap="3x"
        columns={{
          _: '1fr',
          tablet: '1fr 1fr',
        }}
        gridTemplateAreas={{
          _: `
            "info"
            "certificate"
            "action"
          `,
          tablet: `
            "info certificate"
            "action certificate"
            ". certificate"
          `,
        }}
        textAlign={{
          _: 'center',
          tablet: 'left',
        }}
      >
        <Box sx={{ gridArea: 'info' }}>
          <Box variant="text.h5">
            {t(`%{cefrLevel} Certificate of Achievement`, {
              cefrLevel: cefrLevel.toUpperCase(),
            })}
          </Box>
          <Box mt="2x" variant="text.paragraph">
            {t(
              `You completed %{hoursOfLessons} hours of Live Lessons and %{hoursOfStudy} hours of study`,
              {
                hoursOfLessons,
                hoursOfStudy,
              }
            )}
          </Box>
        </Box>
        <Box
          ml={{ tablet: '-8px' }}
          mt={{ _: '-16px', tablet: 0 }}
          sx={{ gridArea: 'action' }}
        >
          <Action href={certification.linkUrl}>{t('View certificate')}</Action>
        </Box>
        <Box sx={{ gridArea: 'certificate' }}>
          <Certificate
            cefrLevel={cefrLevel}
            l2Code={l2Code}
            fullName={fullName}
            licenseNumber={certification.licenseNumber}
            completedAt={certification.completedAt}
          />
        </Box>
      </Grid>
    </PageWrapupCard>
  )
}

export default LevelWrapupCertificate
